export default __webpack_public_path__ + "1cd4be47cdd8a5533c6dfbb27989f973.gif";